import cloneDeep from 'lodash.clonedeep';
import merge from 'lodash.merge';
import set from 'lodash.set';

import types from './constants';
import states from '../../values/enums';

const defaultReducer = (state, action) => (state)

const planningSelect = (state, action) => {
  let next = cloneDeep(state)
  const selection = action.selection
  set(next, 'selections', merge(next.selections, {[selection.type]: selection.data}))
  return next
}

const planningDefault = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'selections', action.selections)
  set(next, 'sort', action.sort)
  set(next, 'report.status', {type: states.COMPLETE})
  set(next, 'report.data', action.report)
  return next
}

const planningActive = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'ui.active', action.active)
  return next
}

const planningAction = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'ui.action', action.action)
  return next
}

const planningSort = (state, action) => {
  let next = cloneDeep(state)
  // changme `ui.``
  set(next, 'sort', action.sort)
  return next
}

const reportPending = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.PENDING})
  return next
}

const reportComplete = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.COMPLETE})
  set(next, 'report.data', action.report)
  return next
}

const reportError = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.ERROR, data: action.error})
  return next
}

const containerPending = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'status', {type: states.PENDING})
  return next
}

const containerComplete = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'status', {type: states.COMPLETE})
  return next
}

const containerError = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'status', {type: states.ERROR, data: action.error})
  return next
}

const actionReducer = {
  [types.PLANNING_SELECT]: planningSelect,
  [types.PLANNING_DEFAULT]: planningDefault,
  [types.PLANNING_ACTIVE]: planningActive,
  [types.PLANNING_ACTION]: planningAction,
  [types.PLANNING_SORT]: planningSort,

  [types.PLANNING_PENDING]: reportPending,
  [types.PLANNING_COMPLETE]: reportComplete,
  [types.PLANNING_ERROR]: reportError,

  [types.CONTAINER_PENDING]: containerPending,
  [types.CONTAINER_COMPLETE]: containerComplete,
  [types.CONTAINER_ERROR]: containerError,
}

export default (state = {}, action = {type: null}) => {
  const reducer = actionReducer[action.type] || defaultReducer
  return reducer(state, action)
}

// FALLING OUT OF SYNC - GROOM ACROSS ALL STATE
// STATE: {reports: {planning: {
//   selections: {
//     {
//       classroom: {value: label:}
//       metric: {value: label:}
//       level: {value: label:}
//       sort: {value: label:}
//     }
//   },
//   sort: {value: label:}
//   report: {
//     data: 'ref:/_test/data/planning',
//     status: {type: 'PENDING/COMPLETE/ERROR', data: {}}
//   }
// }}}